import { ICompanyGroup } from "./getCompanyGroups";
import { apiClient } from "lib/apiClient";
import { IEditUser } from "features/CompanyGroups/interfaces";

export const editUser = async (request: IEditUser): Promise<ICompanyGroup> => {
  const response = await apiClient.put(`/users`, request);

  return response.data;
};
